import React, { useState } from 'react';
import styles from '../cssmodules/sidebar.module.css';
import barLogo from '../assets/images/BarAssociationDeharadunLogo.png'

const RegistrationHeader = () => {

  const styleAnchor = {
    textDecoration: 'none'
  };

  return (
    <header  className={styles.fixed_header}>
      <nav  className={`${styles.navbar}`}>
        {/* Logo */}
        <a style={styleAnchor} href="/" className={`${styles.logo} ms-md-5 ms-0`}>
          <img
            className="rounded-full"
            src={barLogo}
            alt="Logo"
            width="50"
            height="50"
          /> &nbsp;
          <span>Bar Association Dehradun</span>
        </a>
       
      </nav>
    </header>
  );
};




export default RegistrationHeader;